import React from 'react';

const FormBox = ({ children }) => {
  return <div className="card p-5">{children}</div>;
};

export default FormBox;
